import {get} from '@/utils/fetch';

// 机构类型
export function getOrgType() {
	return get({
		url: 'manage/sys/enmu/EnmuOrgType'
	})
}
// 行政区域
export function getAreaList(data) {
	return get({
		url: 'manage/pub/getAreaList',
		data
	})
}
// 学校类型
export function getSchoolType() {
	return get({
		url: 'manage/sys/dict/001/list'
	})
}
// 学校办别
export function getSchoolNatureType() {
	return get({
		url: 'manage/sys/enmu/EnmuSchoolNatureType'
	})
}
// 学校所在地类别
export function getSchoolAddressType() {
	return get ({
		url: 'manage/sys/enmu/EnmuSchooAddressType'
	})
}
// 学校配备类别
export function getSchoolEquipType() {
	return get({
		url: 'manage/sys/enmu/EnmuEquipmentType'
	})
}
// 学校年级
export function getGradeInfo(data) {
  return get({
    url: 'manage/sys/schoolClass/gradeInfo',
    data
  })
}
// 班级类型
export function getTypeOptions(data) {
  return get({
    url: 'manage/sys/schoolClass/classTypeOptions',
    data
  })
}
// 入学年份
export function getYearOptions(data) {
  return get({
    url: 'manage/sys/schoolClass/yearOptions',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/enum.js